import { render } from "./Conclusion.vue?vue&type=template&id=45780b72&scoped=true&ts=true"
import script from "./Conclusion.vue?vue&type=script&lang=ts"
export * from "./Conclusion.vue?vue&type=script&lang=ts"

import "./Conclusion.vue?vue&type=style&index=0&id=45780b72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45780b72"]])

export default __exports__